export default __webpack_public_path__ + "static/media/gallery_01.83424ec4.jpg";